// FilterDropDown.js



/* src/pages/Dashboard/Mentors/Comp/FilterDropDown.js
   --------------------------------------------------------------- */
import React, { useState, useRef, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";

import Classes from "./FilterDropDown.module.css";
import DropDownElem from "./DropDowns/DropDownElem";
import { FilterIcon } from "../../../../../../utils/Icons";

export default function FilterDropDown({ onFilterChange }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  /* close on outside click */
  useEffect(() => {
    const cb = (e) => !dropdownRef.current?.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", cb);
    return () => document.removeEventListener("mousedown", cb);
  }, []);

  /* master filter config (same list) */
  const [filters, setFilter] = useState([
    {
      title: 'Job Title',
      options: ['Founder', 'Senior VP', 'General Partner', 'Board of Director'],
    },
    {
      title: 'Education / University',
      options: [
        "High School Student",
        "College Student (Undergraduate)",
        "Graduate Student (Master’s)",
        "PhD Student/Researcher",
        "Recent Graduate",
        "Entry-Level Professional",
        "Career Switcher",
        "Idea-Stage Founder",
        "Early-Stage Startup Founder",
        "Growth-Stage Startup Founder",
        "Revenue-Generating Founder",
        "Pre-Funding Founder",
        "Post-Funding Founder",
        "First-Time Founder",
        "Serial Founder",
        "Student Entrepreneur",
        "Corporate Intrapreneur"
      ],
    },
    // {
    //   title: 'Clubs / Fraternities / Charities',
    //   options:
    //     [
    //       "option 1",
    //       "option 2",
    //       "option 3",
    //     ],
    // },
    {
      title: 'Areas of Expertise',
      options:
        [
          'Finance', 'Sales', 'Accounting', 'Coding', 'Healthcare', 'Entertainment', 'Law',
          'Marketing', 'Education', 'Real Estate', 'Insurance', 'Energy', 'Entrepreneurship'
        ],
    },
    {
      title: 'Level of Experience',
      options:
        [
          'Entry Level',
          'Associate',
          'Specialist',
          'Supervisor',
          'Manager',
          'Senior Manager',
          'Director',
          'Senior Director',
          'Vice President',
          'Managing Director',
          'Partner',
          'C-Suite Executive',
          'Founder/Co-Founder',
          'Board Member/Advisor'
        ],
    },
    {
      title: 'Language',
      options:
        [
          "English",
          "Spanish",
          "Mandarin Chinese",
          "Hindi",
          "Arabic",
          "Portuguese",
          "French",
          "Urdu",
          "Russian",
          "Bengali",
          "German",
          "Japanese",
          "Korean",
          "Italian",
          "Vietnamese",
          "Turkish",
          "Persian (Farsi)",
          "Swahili",
          "Hebrew",
          "Indonesian",
          "Dutch",
          "Thai",
          "Filipino (Tagalog)",
          "Polish",
          "Ukrainian"
        ],
    },
    {
      title: 'Availability',
      options:
        [
          "Weekdays (Daytime)",
          "Weekdays (Evenings)",
          "Weekends (Daytime)",
          "Weekends (Evenings)",
          "Early Mornings",
          "Lunchtime / Midday",
          "Evenings Only",
          "Flexible / Varies Weekly",
          "By Appointment Only"
        ],
    },
  ]);
  const [selected, setSelected] = useState({});
  const [search, setSearch] = useState("");

  /* bubble up */
  useEffect(() => { onFilterChange && onFilterChange(selected); }, [selected]);

  /* option toggle */
  const toggle = (title, option, checked) =>
    setSelected((p) => {
      const arr = p[title] || [];
      return {
        ...p,
        [title]: checked ? [...arr, option] : arr.filter((v) => v !== option),
      };
    });

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      <div className={Classes.filterCon} onClick={() => setOpen((o) => !o)}>
        <div className={Classes.filterIcon}>
          <FilterIcon height="20" fill="#969696" />
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.filterdropDownBody}
          >
            <div className={Classes.ddPointerCon}>
              <div className={Classes.dropDownPointer} />
            </div>

            <div className={Classes.filterdropDownBodyInner}>
              <h5 className={Classes.filterTitle}>Filters</h5>

              <input
                type="text"
                placeholder="Search filters"
                className={Classes.searchCon}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {filters.map((f, i) => (
                <DropDownElem
                  key={i}
                  filter={f}
                  index={i}
                  selectedOptions={selected[f.title] || []}
                  onOptionChange={toggle}
                  searchTerm={search}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
